<script setup lang="ts">
import { IMarketGroup } from "~/types/racing/market-group";
import t from "~/utils/translate";
interface MarketGroupsProps {
	marketGroups: IMarketGroup[] | undefined;
	isEventActive: boolean | undefined;
	selectedEventId: number | undefined;
}
const props = defineProps<MarketGroupsProps>();
const selectedMarketGroup = ref("");
const emit = defineEmits(["refetch-event"]);

const handleMarketChange = (marketGroup: string) => {
	selectedMarketGroup.value = marketGroup;
	emit("refetch-event", marketGroup);
};
onMounted(() => {
	if (props.marketGroups && props.marketGroups?.length <= 1) {
		selectedMarketGroup.value = "Race Winner";
	}
});
watchEffect(() => {
	if (props.selectedEventId) {
		selectedMarketGroup.value = props.marketGroups && props.marketGroups?.length > 1 ? "" : "Race Winner";
	}
});
</script>
<template>
	<div class="flex">
		<div class="flex overflow-hidden mb-2">
			<div
				class="relative flex flex-1 overflow-x-auto overflow-y-hidden border rounded-lg h-9 bg-light-50 dark:bg-dark-800 border-light-500 dark:border-dark-700 scrollbar-hidden"
			>
				<div
					v-if="marketGroups && marketGroups?.length > 1"
					:class="[
						'flex items-center justify-center px-2 text-xs transition-all cursor-pointer h-full border-r border-r-light-500 dark:border-r-dark-500 whitespace-nowrap font-bold',
						selectedMarketGroup === '' ? 'bg-dark-800 dark:bg-identity text-light-50 more-market-active' : 'bg-light-50 dark:bg-dark-800',
					]"
					@click="handleMarketChange('')"
				>
					{{ t("main") }}
				</div>
				<template v-if="marketGroups?.length">
					<div
						v-for="(market, index) in marketGroups"
						:key="market.id"
						@click="handleMarketChange(market.groupName)"
						:class="[
							'flex items-center justify-center px-2 text-xs transition-all cursor-pointer h-full  whitespace-nowrap font-bold',
							selectedMarketGroup === market.groupName
								? 'bg-dark-800 dark:bg-identity text-light-50 more-market-active'
								: 'bg-light-50 dark:bg-dark-800',
							index + 1 !== marketGroups.length ? 'border-r border-r-light-500 dark:border-r-dark-500' : null,
						]"
					>
						{{ t(market.translationKey) }}
					</div>
				</template>
			</div>
		</div>
	</div>
</template>
